namespace Matrix.Data {
    export interface PartyForm {
        PartyCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        ShortName: Serenity.StringEditor;
        CountryOfDomicileCode: FormatLookupEditor;
        CountryOfIncorporationCode: FormatLookupEditor;
        CountryOfRiskCode: FormatLookupEditor;
        PartyLegalName: Serenity.StringEditor;
        IsPrivateCompany: Serenity.BooleanEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        PartyWebAddress: Serenity.URLEditor;
        PartyFaxNumber: Serenity.StringEditor;
        PartyTelNumber: Serenity.StringEditor;
        AlternativePartyName: Serenity.StringEditor;
        PreviousPartyNames: Serenity.StringEditor;
        PartyRoles: Serenity.CheckLookupEditor;
        SpLtRating: Serenity.LookupEditor;
        SpStRating: Serenity.LookupEditor;
        MoodysLtRating: Serenity.LookupEditor;
        MoodysStRating: Serenity.LookupEditor;
        FitchLtRating: Serenity.LookupEditor;
        FitchStRating: Serenity.LookupEditor;
        InternalLtRating: Serenity.LookupEditor;
        InternalStRating: Serenity.LookupEditor;
        GicsSelection: ModelTargetPicker;
        GicsSector: Serenity.StringEditor;
        GicsIndustryGroup: Serenity.StringEditor;
        GicsIndustry: Serenity.StringEditor;
        GicsSubIndustry: Serenity.StringEditor;
        LegalEntityIdentifier: Serenity.StringEditor;
        LeiName: Serenity.StringEditor;
        LeiEntityStatus: Serenity.StringEditor;
        LeiLegalForm: Serenity.StringEditor;
        LeiAssignedDate: Serenity.DateEditor;
        LeiLastUpdate: Serenity.DateEditor;
        LeiDisabledDate: Serenity.DateEditor;
        LeiRegistrationAddress: Serenity.StringEditor;
        LeiRecordState: Serenity.StringEditor;
        LeiMaintenanceState: Serenity.StringEditor;
        LeiNextMaintenanceDate: Serenity.DateEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PartyForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Party';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartyForm.init)  {
                PartyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.URLEditor;
                var w5 = s.CheckLookupEditor;
                var w6 = s.LookupEditor;
                var w7 = ModelTargetPicker;
                var w8 = s.DateEditor;
                var w9 = StaticTextBlock;
                var w10 = ReadOnlyDateTime;

                Q.initFormType(PartyForm, [
                    'PartyCode', w0,
                    'Name', w0,
                    'ShortName', w0,
                    'CountryOfDomicileCode', w1,
                    'CountryOfIncorporationCode', w1,
                    'CountryOfRiskCode', w1,
                    'PartyLegalName', w0,
                    'IsPrivateCompany', w2,
                    'DefaultSortOrder', w3,
                    'PartyWebAddress', w4,
                    'PartyFaxNumber', w0,
                    'PartyTelNumber', w0,
                    'AlternativePartyName', w0,
                    'PreviousPartyNames', w0,
                    'PartyRoles', w5,
                    'SpLtRating', w6,
                    'SpStRating', w6,
                    'MoodysLtRating', w6,
                    'MoodysStRating', w6,
                    'FitchLtRating', w6,
                    'FitchStRating', w6,
                    'InternalLtRating', w6,
                    'InternalStRating', w6,
                    'GicsSelection', w7,
                    'GicsSector', w0,
                    'GicsIndustryGroup', w0,
                    'GicsIndustry', w0,
                    'GicsSubIndustry', w0,
                    'LegalEntityIdentifier', w0,
                    'LeiName', w0,
                    'LeiEntityStatus', w0,
                    'LeiLegalForm', w0,
                    'LeiAssignedDate', w8,
                    'LeiLastUpdate', w8,
                    'LeiDisabledDate', w8,
                    'LeiRegistrationAddress', w0,
                    'LeiRecordState', w0,
                    'LeiMaintenanceState', w0,
                    'LeiNextMaintenanceDate', w8,
                    'CreatedBy', w9,
                    'CreatedWhen', w10,
                    'UpdatedBy', w9,
                    'UpdatedWhen', w10,
                    'Version', w9
                ]);
            }
        }
    }
}
